/* env file for productoion */
import packageInfo from "../../package.json";

export const environment = {
	versionApp: packageInfo.version,
	production: true,
	notificationsEnabled: false
};
